export const DropZoneBoxStyle = {
  flex: 1,
  display: 'flex',
  width: '75%',
  height: '160px',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: '2px',
  borderRadius: '2px',
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  color: '#D4D4D4',
}
